import { render, staticRenderFns } from "./TgWishcardTextarea.vue?vue&type=template&id=342fccc0&scoped=true&"
import script from "./TgWishcardTextarea.vue?vue&type=script&lang=js&"
export * from "./TgWishcardTextarea.vue?vue&type=script&lang=js&"
import style0 from "./TgWishcardTextarea.vue?vue&type=style&index=0&id=342fccc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342fccc0",
  null
  
)

export default component.exports